var $ = require('jquery');
global.jQuery = global.$ = $

var bootstrap = require('bootstrap');

window.Genetic = require('genetic-js');

var mathjs = require('mathjs')

window.PlotlyConfig = {MathJaxConfig: 'local'};
var Plotly = require('plotly.js-dist')
var d3 = Plotly.d3;

function addNoise(points, sigma) {
  return points.map(function(p) {
    return p + d3.random.normal(0, sigma)()
  });
}

function makeDataPoints(numSamples, polynomialOrder, xMin, xMax) {
  const paramBound = 3;
  var parameters = [];
  for (var i = 0; i < polynomialOrder + 1; i++) {
    parameters[i] = mathjs.random(-paramBound, paramBound);
  }
  console.log("Generated: " + parameters);
  var x = mathjs.random([numSamples], xMin, xMax);
  //var x = d3.range(numSamples).map(function () {return randomUniform(xMin, xMax)});
  x = x.sort(function(x1, x2) {
    return x1 - x2
  });
  var y = mathjs.multiply(parameters[0], mathjs.ones(numSamples));
  for (i = 1; i < polynomialOrder + 1; i++){
    y = mathjs.add(y, mathjs.multiply(parameters[i], mathjs.dotPow(x, i)));
  }
  y = addNoise(y, 1.0);
  return {
    x: x,
    y: y._data,
    name: 'samples',
    type: 'scatter',
    mode: 'markers',
    marker: {
      size: 10
    }
  };
}

function makePolyPoints(coefficients) {
  var x = mathjs.range(xMin, xMax, true);
  var y = x.map(function(x) {
    return evaluatePoly(coefficients, x)
  });
  return {
    x: x._data,
    y: y._data
  };
}

function plotPoly(graphDiv, coefficients) {
  var points = makePolyPoints(coefficients);
  Plotly.addTraces(graphDiv, {
    x: points.x,
    y: points.y,
    mode: 'lines',
    line: {
      color: 'red'
    },
    name: 'result'
  });
}

function updatePoly(graphDiv, coefficients, traceIdx) {
  var points = makePolyPoints(coefficients);
  Plotly.animate(graphDiv, {
    data: [{
      y: points.y
    }],
    traces: [traceIdx],
    layout: {}
  }, {
    transition: {
      duration: 100,
      easing: 'cubic-in-out'
    },
    frame: {
      duration: 100
    }
  })
}

function plotWinnerIndividual(populationSelector, pop) {
  // TODO
  if (pop[0].entity.length != 2) {
    return;
  }

  fittestIndividual = pop[0];
  Plotly.addTraces(populationSelector.get(0), [{
    x: [fittestIndividual.entity[0]],
    y: [fittestIndividual.entity[1]],
    name: 'fittest individual',
    type: 'scatter',
    mode: 'markers',
    marker: {
      size: 10,
      color: 'red'
    }
  }]);
}

function addHoverCallback(populationSelector, graphDiv) {
  var lastTraceIdx = $('#scatter').get(0).data.length - 1;
  populationSelector.off();
  populationSelector.get(0).removeAllListeners('plotly_hover');
  populationSelector.get(0).on('plotly_hover', function(data) {
    var parameters = [];
    var b = data.points[0].y;
    var c = data.points[0].x;
    parameters = [c, b];
    if (data.points[0].z != undefined){
      parameters.push(data.points[0].z);
    }
    updatePoly(graphDiv, parameters, lastTraceIdx);
  });
  populationSelector.mouseleave(function(event) {
    updatePoly(graphDiv, fittestIndividual.entity, lastTraceIdx);
  });
}

function updatePopulation(populationSelector, pop) {
  // TODO
  if (pop[0].entity.length != 2) {
    return;
  }

  var b = pop.map(function(individual) {
    return individual.entity[0]
  });
  var a = pop.map(function(individual) {
    return individual.entity[1]
  });
  Plotly.animate(populationSelector.get(0), {
    data: [{
      x: b,
      y: a
    }],
    traces: [0],
    layout: {}
  }, {
    transition: {
      duration: 100,
      easing: 'cubic-in-out'
    },
    frame: {
      duration: 100,
      //redraw: false
    }
  });
}

var xMin = -10.0,
  xMax = 10.0;
var numSamples = 100;

var polynomialOrder;
var data;
function makeDataset(polynomialOrder) {
  return [makeDataPoints(numSamples, polynomialOrder, xMin, xMax)];
}
function plotDataset(datasetPlotDiv, dataset) {
  var layout = {
    title: $('#polyDegreeSelect option:selected').text()
  };
  Plotly.newPlot(datasetPlotDiv, data, layout);
}
function makeAndPlotDataset(){
  polynomialOrder = parseInt($('#polyDegreeSelect option:selected').val());
  data = makeDataset(polynomialOrder);
  plotDataset($('#scatter').get(0), data);
  //reset population and results
  $('#solution-card').collapse('hide');
  $('#solution-card').prev('p').collapse('show');
  Plotly.purge($('#populationPlot').get(0));
  Plotly.purge($('#bestFitPerGeneration').get(0));
}

$('#polyDegreeSelect').change(makeAndPlotDataset);
makeAndPlotDataset();

function addOptionsFromObject(select, object) {
  for (var key in object){
    select.append($('<option>', {value: key, text: key}));
  }
}
addOptionsFromObject($('#selection1TypeInput'), Genetic.Select1);
addOptionsFromObject($('#selection2TypeInput'), Genetic.Select2);

g = window.Genetic.create();

g.optimize = Genetic.Optimize.Minimize;

$('#selection1TypeInput').change(function () {
  g.select1 = Genetic.Select1[this.value];
}).change();

$('#selection2TypeInput').change(function () {
  g.select2 = Genetic.Select2[this.value];
}).change();

g.seed = function() {
  return mathjs.random([this.userData["numCoefficients"]], -1, 1);
}

function makeMutationFun (maxDriftInput){
  var maxDrift = maxDriftInput;
  return function(entity) {
    var drift = mathjs.random(-maxDrift, maxDrift);

    var i = mathjs.randomInt(entity.length);
    entity[i] += drift;

    return entity;
  }
}

$('#mutationDriftInput').change(function(){
  g.mutate = makeMutationFun(+(this.value));
}).change();

g.crossover = function(mother, father) {
  // crossover via interpolation
  function lerp(a, b, p) {
    return a + (b - a) * p;
  }

  var len = mother.length;
  var i = mathjs.randomInt(len);
  var r = mathjs.random();
  var son = [].concat(father);
  var daughter = [].concat(mother);

  son[i] = lerp(father[i], mother[i], r);
  daughter[i] = lerp(mother[i], father[i], r);

  return [son, daughter];
};

// example 3 term polynomial: cx^0 + bx^1 + ax^2
var evaluatePoly = function(coefficients, x) {
  var s = 0;
  var p = 1;
  for (var i = 0; i < coefficients.length; ++i) {
    s += p * coefficients[i];
    p *= x;
  }

  return s;
};

g.fitness = function(entity) {
  var evaluatedPoints = this.userData['points'].x.map(function(x) {
    return evaluatePoly(entity, x);
  });
  var error = mathjs.subtract(evaluatedPoints, this.userData['points'].y);
  var squaredError = mathjs.sum(mathjs.dotPow(error, 2));
  return mathjs.sqrt(squaredError);
};

function animatePopulationHistory(popDiv, popHistory) {
  function makePopulationTraces(pop){
    var popTrace = {
      name: 'population',
      x: pop.map(function (individual) {return individual.entity[0]}),
      y: pop.map(function (individual) {return individual.entity[1]}),
      type: 'scatter',
      mode: 'markers',
      marker: {
        size: 10,
        color: 'blue',
        opacity: 0.8
      }
    };
    var bestTrace = {
      name: 'best individual',
      x: [pop[0].entity[0]],
      y: [pop[0].entity[1]],
      type: 'scatter',
      mode: 'markers',
      marker: {
        size: 10,
        color: 'red',
        opacity: 0.8
      }
    };
    if (pop[0].entity.length > 2){
      popTrace.z = pop.map(function (individual) {return individual.entity[2]});
      bestTrace.z = [pop[0].entity[2]];
      popTrace.type = 'scatter3d';
      bestTrace.type = 'scatter3d';
    }
    return [popTrace, bestTrace];
  }

  var frames = [];
  var sliderSteps = [];
  for (let popStep of popHistory) {
    frames.push({
      name: popStep.generation.toString(),
      data: makePopulationTraces(popStep.population),
    });
    sliderSteps.push({
          method: 'animate',
          label: popStep.generation,
          //args passed to Plotly.animate
          args: [
            [popStep.generation.toString()], {
                  mode: 'immediate',
                  transition: {
                    duration: 300
                  },
                  frame: {
                    duration: 300,
                    redraw: false
                  }
                }
              ]
            });
  }


  var layout = {
    title: 'Population',
    xaxis: {
      title: {
        text: 'b'
      },
      range: [-2, 2]
    },
    yaxis: {
      title: {
        text: 'a'
      },
      range: [-3, 3]
    },
    hovermode: 'closest',
    updatemenus: [{
      x: 0,
      y: 0,
      yanchor: 'top',
      xanchor: 'left',
      showactive: false,
      direction: 'left',
      type: 'buttons',
      pad: {
        t: 87,
        r: 10
      },
      buttons: [{
        method: 'animate',
        args: [null, {
          mode: 'immediate',
          fromcurrent: true,
          transition: {
            duration: 300
          },
          frame: {
            duration: 500,
            redraw: false
          }
        }],
        label: 'Play'
      }, {
        method: 'animate',
        args: [
          [null], {
            mode: 'immediate',
            transition: {
              duration: 0
            },
            frame: {
              duration: 0,
              redraw: false
            }
          }
        ],
        label: 'Pause'
      }]
    }],
    // Finally, add the slider and use `pad` to position it
    // nicely next to the buttons.
    sliders: [{
      pad: {
        l: 130,
        t: 55
      },
      currentvalue: {
        visible: true,
        prefix: 'Generation:',
        xanchor: 'right',
        font: {
          size: 20,
          color: '#666'
        }
      },
      steps: sliderSteps
    }]
  }; //layout
  if (popHistory[0].population[0].entity.length > 2) {
    layout.margin = {
      l: 0,
      r: 0,
      b: 0,
      t: 0
    };
    layout.scene = {
      xaxis: {
        title: {
          text: 'c'
        },
        range: [-3,3]
      },
      yaxis: {
        title: {
          text: 'b'
        },
        range: [-3,3]
      },
      zaxis: {
        title: {
          text: 'a'
        },
        range: [-3,3]
      }
    };
  }

  Plotly.newPlot(popDiv, {
    data: makePopulationTraces(popHistory[0].population),
    layout: layout,
    frames: frames
  });
}

function formatPoly (coefficients){
  var formattedPoly = "$$ y = ";
  for(var i = coefficients.length - 1; i > 0; i--) {
    var c = coefficients[i];
    formattedPoly = formattedPoly.concat((c >= 0 ? "+" : ""), c.toPrecision(4), "x");
    if (i > 1){
      formattedPoly = formattedPoly.concat("^", i);
    }
  }
  c = coefficients[0];
  formattedPoly = formattedPoly.concat((c >= 0? "+":""), c.toPrecision(4), " $$");
  return formattedPoly;
}

function plotBestFitPerGeneration (plotDiv, populationHistory){

  var traces = {
    x: populationHistory.map(function (val) {return val.generation}),
    y: populationHistory.map(function (val) {return val.population[0].fitness}),
    mode: 'lines'
  };
  var layout = {
    title: 'Error per Generation',
    'xaxis': {
      title: 'generation'
    },
    'yaxis': {
      title: 'error'
    }
  };
  Plotly.newPlot(plotDiv, [traces], layout);
}

var maxIterations;
var populationHistory = [];
g.notification = function(pop, generation, stats, isFinished) {
  console.log("generation: " + generation);
  populationHistory.push({
    population: pop,
    generation: generation
  });

  //update progressbar
  var progress = Math.floor((generation / maxIterations) * 100);
  $('#evolution-progress > .progress-bar').css('width', progress.toString()+"%");

  if (isFinished) {
    console.log("Finished!");
    $('#evolution-progress > .progress-bar').css('width', "100%");
    $('#evolution-progress').collapse('hide');
    //console.log(pop[0].entity);
    fittestIndividual = pop[0];
    plotPoly($('#scatter').get(0), pop[0].entity);
    animatePopulationHistory($('#populationPlot').get(0), populationHistory);
    addHoverCallback($('#populationPlot'), $('#scatter').get(0));
    plotBestFitPerGeneration($('#bestFitPerGeneration').get(0), populationHistory);
    $('#solve').prop( "disabled", false );
    $('#solve > span').collapse('hide');
    $('#solution-card').collapse('show');

    $('#final-generation > b').html(generation + 1);
    $('#bestfit > b').html(pop[0].fitness.toPrecision(4));
    $('#avg-fitness > b').html(stats.mean.toPrecision(4));
    $('#std-fitness > b').html(stats.stdev.toPrecision(4));
    $('#solution > span').html(formatPoly(fittestIndividual.entity));
    MathJax.Hub.Queue(["Typeset",MathJax.Hub, $('#solution').get(0)]);
  }
};

function getConfigFromForm(){
  const iterationsToSkipNotification = 2;
  maxIterations = parseInt($('#numIterationsInput').val());
  return {
    "iterations": maxIterations,
    "size": parseInt($('#populationSizeInput').val()),
    "crossover": +($('#crossoverProbabilityInput').val()),
    "mutation": +($('#mutationProbabilityInput').val()),
    webWorkers: false, //workaround TODO: try to remove
    "skip": iterationsToSkipNotification
  };
}

$('#solve').click(function() {
  var config = getConfigFromForm();
  var userData = {
    numCoefficients: (polynomialOrder + 1),
    points: data[0]
  };

  $('#solve').prop("disabled", true);
  $('#solution-card').prev('p').collapse('hide');
  $('#solve > span').collapse('show');
  $('#evolution-progress').collapse('show');
  $('#evolution-progress').one('shown.bs.collapse', () => {
    populationHistory = [];
    g.entities = [];
    g.evolve(config, userData);
  });
});

$('#restart').click(function(){
  makeAndPlotDataset();
});
